// extracted by mini-css-extract-plugin
module.exports = {"total":"detail_total__3iDYA"};